'use client';
import React from 'react';
import { Zap } from 'lucide-react';
import Link from 'next/link';

const footerLinks = [
  {
    title: 'Product',
    links: [
      { label: 'How It Works', href: '#how-it-works', isRoute: false },
      { label: 'See AgentOS in Action', href: '/in-action', isRoute: true },
      { label: 'Pricing', href: '#pricing', isRoute: false },
      { label: 'For Teams', href: '#for-teams', isRoute: false },
      { label: 'AI Command Center', href: 'https://agentos-ai-vgojf93.public.builtwithrocket.new/', isRoute: false, external: true },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '#', isRoute: false },
      { label: 'Resources', href: '#faq', isRoute: false },
      { label: 'Contact', href: '#contact', isRoute: false },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Help Center', href: '#', isRoute: false },
      { label: 'Documentation', href: '#', isRoute: false },
      { label: 'Status', href: '#', isRoute: false },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '#', isRoute: false },
      { label: 'Terms of Service', href: '#', isRoute: false },
      { label: 'Fair Housing', href: '#', isRoute: false },
    ],
  },
];

const socialLinks = [
  {
    label: 'X (Twitter)',
    color: '#F0F4FF',
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: 'Instagram',
    color: '#E1306C',
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    color: '#0A66C2',
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: 'TikTok',
    color: '#FF2D55',
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z" />
      </svg>
    ),
  },
];

export default function Footer() {
  const handleNavClick = (href: string, isRoute?: boolean, external?: boolean) => {
    if (isRoute) return; // handled by Link component
    if (external) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <footer
      style={{
        background: '#0B0F19',
        borderTop: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div
                className="w-8 h-8 rounded-xl flex items-center justify-center"
                style={{
                  background: 'linear-gradient(135deg, #00D4FF, #0099CC)',
                  boxShadow: '0 4px 12px rgba(0,212,255,0.35)',
                }}
              >
                <Zap size={16} className="text-black" strokeWidth={2.5} />
              </div>
              <span className="font-extrabold text-lg tracking-tight" style={{ color: '#F0F4FF' }}>AgentOS</span>
            </div>
            <p className="text-sm leading-relaxed mb-4" style={{ color: 'rgba(240,244,255,0.40)' }}>
              Your AI Business Partner for Real Estate. Organize your business, prioritize opportunities, and start every day knowing exactly what matters most.
            </p>
            <Link
              href="/in-action"
              className="inline-flex items-center gap-1.5 text-xs font-semibold mb-6 transition-colors"
              style={{ color: 'rgba(0,212,255,0.65)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00D4FF'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(0,212,255,0.65)'; }}
            >
              See AgentOS in Action →
            </Link>
            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href="#"
                  aria-label={social.label}
                  className="w-9 h-9 rounded-xl flex items-center justify-center transition-all"
                  style={{
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.10)',
                    color: 'rgba(240,244,255,0.45)',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLElement).style.background = `${social.color}18`;
                    (e.currentTarget as HTMLElement).style.borderColor = `${social.color}40`;
                    (e.currentTarget as HTMLElement).style.color = social.color;
                    (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.06)';
                    (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.10)';
                    (e.currentTarget as HTMLElement).style.color = 'rgba(240,244,255,0.45)';
                    (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                  }}
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4
                className="text-xs font-bold uppercase tracking-widest mb-4"
                style={{ color: 'rgba(240,244,255,0.30)', fontFamily: 'JetBrains Mono, monospace' }}
              >
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.isRoute ? (
                      <Link
                        href={link.href}
                        className="text-sm transition-colors text-left"
                        style={{ color: 'rgba(240,244,255,0.45)' }}
                        onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00D4FF'; }}
                        onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(240,244,255,0.45)'; }}
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <button
                        onClick={() => handleNavClick(link.href, link.isRoute, link.external)}
                        className="text-sm transition-colors text-left"
                        style={{ color: 'rgba(240,244,255,0.45)' }}
                        onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00D4FF'; }}
                        onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(240,244,255,0.45)'; }}
                      >
                        {link.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div
          className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
        >
          <p className="text-xs" style={{ color: 'rgba(240,244,255,0.25)', fontFamily: 'JetBrains Mono, monospace' }}>
            &copy; 2026 AgentOS. All rights reserved. Built for real estate professionals.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://agentos-ai-vgojf93.public.builtwithrocket.new/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-medium transition-colors"
              style={{ color: 'rgba(240,244,255,0.35)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00D4FF'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(240,244,255,0.35)'; }}
            >
              AI Command Center ↗
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
